module.exports = __webpack_public_path__ + "static/media/MessageOptimized.66fc8944.jp2";